<template>
  <v-card>
    <v-card-title>
      <div>
        <div class="headline">Permitted Promotions</div>
      </div>
      <v-spacer></v-spacer>
      <v-flex xs6>
        <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
      </v-flex>
    </v-card-title>
    <v-data-table v-bind:headers="headers" v-bind:items="items" v-bind:search="search" :rows-per-page-items="itemsPerPage" v-bind:pagination.sync="pagination" item-key="promotion" :loading="loading" :no-data-text="noDataText" :filter="customSearch">
      <template slot="items" slot-scope="props">
        <td>{{ props.item.promotion }}</td>
        <td class="text-xs-left">{{ props.item.promotionDesc }}</td>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { expandURI } from '@/utils/ajax'

export default {
  data() {
    return {
      headers: [
        { text: 'Promotion Code', align: 'left', value: 'promotion', sortable: false },
        { text: 'Promotion Description', align: 'left', value: 'promotionDesc', sortable: false }
      ],
      totalItems: 0,
      loading: false,
      items: []
    }
  },
  methods: {
    async doInit() {
      await this.queryCampaignPromotions()
    },
    async queryCampaignPromotions() {
      const apiURI = this.$store.state.promotionManagement.campaign.menu.campaignPromotions
      if (apiURI) {
        try {
          this.loading = true
          const expand = {
            campaign: this.campaign
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          if (result.data) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            if (data) {
              // Format the data here
              this.items = []
              data.map((campaignPromo) => {
                const convertCampaignPromo = {
                  campaign: campaignPromo.campaign,
                  campaignDesc: campaignPromo.campaignDesc,
                  promotion: campaignPromo.promotion,
                  promotionDesc: campaignPromo.promotionDesc
                }
                this.items.push(convertCampaignPromo)
              })
            } else {
              this.items = []
            }
          }
          this.loading = false
        } catch (err) {
          throw err
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    }
  },
  props: {
    campaign: {
      type: String,
      default: ''
    }
  },
  created() {
    this.doInit()
  },
  mixins: [
    TableConst.default
  ]
}
</script>

<style lang="scss">
</style>
